import { EntityType } from '../services/entities/entity-type.class';
import { Entity } from './entity.class';
import { Hiring } from './hiring';
import { Planning } from './planning.class';

export class PlanningDumper {
    entitytype_key: string;
    entity_id: number;
    entitytype?: EntityType;
    planning_id: number;
    driver_user_id: number;
    truck_entity_id: number;
    lowloader_entity_id: number;
    lowloader_entity?: Entity;
    begindate: Date;
    enddate: Date;
    name: string;
    created_at: Date;
    updated_at: Date;
    id: number;
    count: number;
    hiring_id: number;
    hiring?: Hiring;
    entity: Entity;
    planning: Planning;
    comment: string;
    driver?: string;
}
